module.exports = __webpack_public_path__ + "img/tjlb1.ab5f3a72.jpg";